module.exports = "fb669f9040684b828e6d67a7fb0c9196.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/laser emitter.png
// module id = 67
// module chunks = 0